import type {AcceptRecommendationRequest} from '@app/api-resolver/router'
import type {RecommendationId} from '@package/shared'

export const extractRecommendationIds = (request: AcceptRecommendationRequest): RecommendationId[] => {
  return 'recommendations' in request //
    ? request.recommendations.map(({id}) => id)
    : [request.id]
}
